<template>
  <div>
    <vs-button color="dark" type="border" @click="dialogIsVisible=true">خروجی اکسل</vs-button>
    <vs-popup title="خروجی اکسل" :active.sync="dialogIsVisible">
      <vs-input v-model="fileName" placeholder="نام فایل را وارد کنید" class="w-full"/>
      <!--      <v-select v-model="selectedFormat" :options="formats" class="my-4"/>-->
      <!--      <div class="flex">-->
      <!--        <span class="mr-4">Cell Auto Width:</span>-->
      <!--        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>-->
      <!--      </div>-->
      <vs-button @click="exportToExcel" class="mt-5">اعمال</vs-button>
    </vs-popup>
  </div>
</template>

<script>
  import vSelect from 'vue-select'

  export default {
    components: {
      vSelect
    },
    data() {
      return {
        dialogIsVisible: false,
        fileName: "",
        // formats: ["xlsx", "csv", "txt"],
        cellAutoWidth: true,
        selectedFormat: "xlsx",
        headerTitle: Object.values(this.config.fields),
        headerVal: Object.keys(this.config.fields),
      }
    },
    methods: {
      exportToExcel() {
        this.$vs.notify({
          title: 'در حال ساخت فایل...', text: '', color: 'warning', position: 'top-center'
        })
        import('xlsx/Export2Excel').then(excel => {
          const data = this.formatJson(this.headerVal, this.list)
          excel.export_json_to_excel({
            header: this.headerTitle,
            data,
            filename: this.fileName,
            autoWidth: this.cellAutoWidth,
            bookType: this.selectedFormat
          })
          this.clearFields()
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          // Add col name which needs to be translated
          // if (j === 'timestamp') {
          //   return parseTime(v[j])
          // } else {
          //   return v[j]
          // }

          return v[j]
        }))
      },
      clearFields() {
        this.filename = ""
        this.cellAutoWidth = true
        this.selectedFormat = "xlsx"
        this.dialogIsVisible = false
      },
      // getList() {

        // if (this.config.table === 'students') {
        //   return this.$store.state.students;
        // }else if('drivers'){
        //   return this.$store.state.drivers;
        // }
      // }
    },
    props: {
      config: [Object],
      list : [Array]
    }
  }
</script>
